import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 dílů', '5 bonusů', '240 stran', '1.–9. ročník'];
const reassurances = ['Okamžitě ke stažení', 'PDF k tisku', '7denní záruka spokojenosti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15bsn7i7giakm">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbk7u1shap7l" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ebxrhjhcssuk">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1mz9xjybv3t">
          Vaše hodiny výtvarky můžou být <em className="text-red-700" data-id="element-118" data-mp="1o67mza1le79i">hotové už dnes.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="2245xg4csljjq">
          Místo hledání nápadů, příprav všeho na vlastní pěst a nedělních večerů nad plánováním
          máte přehledný balíček výtvarné výchovy na celý školní rok. Víc času na to,
          na čem opravdu záleží:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s6s0y5kg81e1">
          Vaši žáci. Jejich díla. Váš život mimo školu.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="123ws6jt5in1p">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="162dw6uh9zhew">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b2ruhkt2rczq">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1fvb7ognuo640"><span className="sr-only" data-id="element-125" data-mp="1kt3a44m4famg">Původně </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1pspqgmx8x6zh">Jednorázová platba – žádné předplatné.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1ttrpp3r5xj1g">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="1tukmpd0bku6e" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qtvy8fqed8ha">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3lx5k3xy5kmyi">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3huxj0knqvky" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}